import { observer } from 'mobx-react';
import { useRootStore } from '@nandosaus/state-management';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { withAppProps } from '@utils/with-app-props';
import { Box, Container, Flex } from '../../components/grid';
import { colors } from '../../constants/colors';
import { decals } from '../../components/decal/constants';
import { floodlightPageLoadEventPropTypes } from '../../prop-types';
import { Layout } from '../../components/layout';
import { Link } from '../../components/link';
import { navigation } from '../../constants';
import { P, Subheading } from '../../components/typography';
import { PageHeaderBlock } from '../../components/content-image';
import { seoPropDefaults, seoPropTypes } from '../../utils/extract-seo-meta-from-entry';

const Help = ({ metaContent, floodlightPageLoadEvent }) => {
  const { MemberStore } = useRootStore();
  return (
    <Layout title="Help" metaContent={metaContent} floodlightPageLoadEvent={floodlightPageLoadEvent}>
      <>
        <PageHeaderBlock
          heading="How can we help you?"
          leftDecal={decals.restaurants.left}
          leftDecalStyle={{ height: '70%' }}
          rightDecalStyle={{ height: '70%' }}
          rightDecal={decals.restaurants.right}
          contentPosition="center"
          contentAlignment="center"
        />
        <Container flex={1}>
          <Flex justifyContent="center" width="100%" mb={2}>
            <P variant={2}>Select an option:</P>
          </Flex>
          <Flex justifyContent="center" flexDirection={{ _: 'column', sm: 'row' }} width="100%" gap="1rem">
            <LinkButton href={process.env.helpUrl} target="_blank">
              <Subheading mb={1} mt={0} variant={2}>
                General Questions
              </Subheading>
              <P variant={4}>Please look at our FAQs and other topics you may need help with.</P>
            </LinkButton>
            <LinkButton href={MemberStore.isSignedIn ? navigation.ORDERS : navigation.ORDER_HELP}>
              <Subheading mb={1} mt={0} variant={2}>
                Help with an order
              </Subheading>
              <P variant={4}>Are you missing any items? Did something go wrong with your order? We’re here to help.</P>
            </LinkButton>
          </Flex>
        </Container>
      </>
    </Layout>
  );
};

const LinkButton = ({ href, target, children }) => (
  <Link href={href} target={target} width={{ xs: 12 / 12, lg: 4 / 12 }}>
    <StyledButton
      bg="rgb(246, 246, 246)"
      p={1}
      textAlign="center"
      borderRadius="1rem"
      cursor="pointer"
      border="2px solid transparent"
      color={colors.black}
    >
      {children}
    </StyledButton>
  </Link>
);

LinkButton.propTypes = {
  href: PropTypes.string.isRequired,
  target: PropTypes.string,
  children: PropTypes.node.isRequired,
};

LinkButton.defaultProps = {
  target: null,
};

const StyledButton = styled(Box)`
  transition: 200ms ease;
  text-decoration: none;
  &:hover {
    border: 2px solid ${({ theme }) => theme.colors.info900};
  }
`;

Help.propTypes = {
  metaContent: PropTypes.shape(seoPropTypes),
  floodlightPageLoadEvent: floodlightPageLoadEventPropTypes,
};

Help.defaultProps = {
  metaContent: seoPropDefaults,
  floodlightPageLoadEvent: undefined,
};

export const getStaticProps = withAppProps(async () => {
  return {
    props: {
      title: 'Help',
    },
  };
});

export default observer(Help);
